module.exports = __webpack_public_path__ + "images/Plus_small.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Plus_small.png
// module id = 191
// module chunks = 0 1